import { useState } from "react";

import { C, IG_HANDLE, SHIPPING_ZONES, WOMPI_API_PROXY, fmtMoney, genId } from "../data/handcraftsConfig";
function getAvailabilityMeta(product, isSold) {
  if (isSold) return { label: "Agotado", bg: "#fef2f2", color: "#dc2626" };
  if (product.stock === 1) return { label: "Ultima pieza", bg: "#fff7ed", color: "#ea580c" };
  if (typeof product.stock === "number" && product.stock > 1) {
    return { label: "Disponible", bg: "#ecfdf5", color: "#059669" };
  }
  return { label: "Por encargo", bg: "#eff6ff", color: "#2563eb" };
}


function ProductCard({ p, addedId, onDetail, onBuy, soldIds }) {
  const isSold = soldIds && soldIds.includes(p.id);
  const availability = getAvailabilityMeta(p, isSold);
  return (
    <div className="product-card" style={{position:"relative",opacity:isSold ? 0.65 : 1}}>
      {isSold
        ? <span style={{position:"absolute",top:13,left:13,zIndex:2,background:"#ef4444",color:"white",fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:11,padding:"4px 10px",borderRadius:20,letterSpacing:"1px",textTransform:"uppercase"}}>Agotado</span>
        : p.badge && <span className="badge" style={{position:"absolute",top:13,left:13,zIndex:2}}>{p.badge}</span>
      }
      {addedId===p.id && <span className="added-flash">✓ ¡Agregado!</span>}
      <div style={{background:C.cream,cursor:"pointer",filter:isSold?"grayscale(40%)":"none",display:"flex",alignItems:"center",justifyContent:"center",minHeight:240}} onClick={()=>onDetail(p)}>
        <img src={p.img} alt={p.name} style={{width:"100%",maxHeight:280,objectFit:"contain",display:"block",transition:"transform .4s ease"}}
          onMouseEnter={e=>{ if(!isSold) e.currentTarget.style.transform="scale(1.04)"; }}
          onMouseLeave={e=>e.currentTarget.style.transform="scale(1)"} />
      </div>
      <div style={{padding:"18px 20px 22px",flex:1,display:"flex",flexDirection:"column"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:5}}>
          <h3 style={{fontSize:17,lineHeight:1.2,cursor:"pointer"}} onClick={()=>onDetail(p)}>{p.name}</h3>
          <span className="sans" style={{fontWeight:800,fontSize:18,color:isSold?"#b0a0a8":C.pink,flexShrink:0,marginLeft:8}}>${p.price}</span>
        </div>
        <p className="sans" style={{color:C.brownLt,fontSize:13,lineHeight:1.6,marginBottom:8,flex:1}}>{p.desc}</p>
        <div style={{display:"flex",gap:6,marginBottom:10,flexWrap:"wrap"}}>
          <span
            className="sans"
            style={{fontSize:10,fontWeight:800,padding:"5px 9px",borderRadius:999,background:availability.bg,color:availability.color,letterSpacing:".3px"}}
          >
            {availability.label}
          </span>
          {["Hecho a mano", "Ideal para regalo"].map((label) => (
            <span
              key={label}
              className="sans"
              style={{fontSize:10,fontWeight:800,padding:"5px 9px",borderRadius:999,background:C.paper,color:C.brownMd,letterSpacing:".3px"}}
            >
              {label}
            </span>
          ))}
        </div>
        <div style={{display:"flex",gap:8,marginBottom:14}}>
          <span className="sans" style={{fontSize:11,color:C.brownLt}}>⏱ {p.tiempo}</span>
          <span style={{color:C.brownLt,fontSize:11}}>·</span>
          <span className="sans" style={{fontSize:11,color:C.brownLt}}>📏 {p.dificultad}</span>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn btn-outline" style={{flex:"0 0 auto",fontSize:12,padding:"8px 13px"}} onClick={()=>onDetail(p)}>Ver más</button>
          {isSold
            ? <button className="btn" disabled style={{flex:1,fontSize:13,padding:"10px 0",background:"#e8dde8",color:"#b0a0a8",borderRadius:50,border:"none",cursor:"not-allowed",fontFamily:"Nunito,sans-serif",fontWeight:800}}>Agotado</button>
            : <button className="btn btn-solid" style={{flex:1,fontSize:13,padding:"10px 0"}} onClick={()=>onBuy(p)}>Comprar 💳</button>
          }
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  CHECKOUT MODAL  (cart → confirm → wompi redirect)
// ─────────────────────────────────────────────────────────────────────────────
function CheckoutModal({ cart, onClose, onSuccess }) {

  const [step, setStep]       = useState("summary"); // "summary" | "loading" | "done" | "error"
  const [orderId]             = useState(() => genId());
  const [errMsg, setErrMsg]   = useState("");
  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    phone: "",
    instagram: "",
    address: "",
    city: "",
    country: "El Salvador",
    notes: "",
    shippingZone: "sv_metro",
  });

  const subtotal  = cart.reduce((s, p) => s + p.price * p.qty, 0);
  const igDMUrl   = `https://www.instagram.com/${IG_HANDLE}/`;
  const returnUrl = `${window.location.origin}${window.location.pathname}?page=pago-resultado&orderId=${encodeURIComponent(orderId)}`;

  // ── Call PHP proxy → Wompi SV API → get urlEnlace ────────────────────────
  // Wompi El Salvador uses OAuth2 + REST (not a public-key widget).
  // Credentials stay server-side in api/wompi.php.
  const handleWompi = async () => {
    if (!customer.name.trim() || !customer.phone.trim() || !customer.city.trim()) {
      setErrMsg("Completa nombre, telefono y ciudad antes de continuar.");
      setStep("error");
      return;
    }

    setStep("loading");
    setErrMsg("");
    try {
      const productNames = cart.map(p => `${p.name} x${p.qty}`).join(", ");
      const wompiPayload = {
        identificadorEnlaceComercio: orderId,
        monto: subtotal,
        nombreProducto: productNames.slice(0, 490),
        descripcionProducto: `Pedido Handcrafts By Abu: ${productNames}`.slice(0, 1000),
        detalleProductos: cart.map((p) => ({
          id: p.id,
          nombre: p.name,
          cantidad: p.qty,
          precioUnitario: p.price,
          subtotal: Number((p.price * p.qty).toFixed(2)),
        })),
        redirectUrl: returnUrl,
        urlRedirect: returnUrl,
        metadata: {
          source: "handcraftsbyabu-web",
          orderId,
          customerName: customer.name,
          customerPhone: customer.phone,
          customerCity: customer.city,
        },
      };
      const res = await fetch(WOMPI_API_PROXY, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(wompiPayload),
      });
      const data = await res.json();
      if (!res.ok || !data.urlEnlace) {
        throw new Error(data.error || "No se pudo crear el enlace de pago.");
      }
      onSuccess(orderId, "Wompi", customer);
      window.location.assign(data.urlEnlace);
      setStep("done");
    } catch (e) {
      setErrMsg(e.message || "Error al conectar con Wompi.");
      setStep("error");
    }
  };

  return (
    <div className="overlay" onClick={step==="done" ? undefined : onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}
        style={{maxWidth:500, padding:0, overflow:"hidden", display:"flex", flexDirection:"column", maxHeight:"92vh"}}>

        {/* ── HEADER ── */}
        <div style={{background:`linear-gradient(135deg,${C.pink},${C.purple})`,padding:"20px 24px",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
            <div>
              <div style={{fontFamily:"Playfair Display,serif",fontSize:19,fontWeight:700,color:"white",lineHeight:1.2}}>
                {step==="summary" ? "🛒 Tu Pedido" : step==="loading" ? "⏳ Creando pago..." : step==="error" ? "⚠️ Error" : "🎉 ¡Pedido Confirmado!"}
              </div>
              {step !== "done" && step !== "loading" && (
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:"rgba(255,255,255,.65)",marginTop:3}}>
                  Pedido #{orderId}
                </div>
              )}
            </div>
            {step !== "done" && step !== "loading" && (
              <button onClick={onClose}
                style={{background:"rgba(255,255,255,.2)",border:"none",borderRadius:50,width:30,height:30,
                  cursor:"pointer",color:"white",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                ✕
              </button>
            )}
          </div>
        </div>

        {/* ── BODY ── */}
        <div style={{overflowY:"auto",flex:1,padding:"22px 24px"}}>

          {/* STEP 1 — ORDER SUMMARY + WOMPI */}
          {step==="summary" && (
            <div>
              {/* Items */}
              <div style={{background:C.paper,borderRadius:14,padding:"16px 18px",border:`1.5px solid ${C.pink}22`,marginBottom:16}}>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown,marginBottom:12}}>
                  📋 Resumen del pedido
                </div>
                {cart.map((p,i) => (
                  <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
                    <div style={{display:"flex",alignItems:"center",gap:10}}>
                      <img src={p.img} alt={p.name} style={{width:40,height:40,objectFit:"cover",borderRadius:8,border:`1px solid ${C.paper}`,flexShrink:0}}/>
                      <div>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:700,color:C.brown}}>{p.name}</div>
                        <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt}}>× {p.qty}</div>
                      </div>
                    </div>
                    <div style={{fontFamily:"Nunito,sans-serif",fontSize:13,fontWeight:800,color:C.pink}}>{fmtMoney(p.price*p.qty)}</div>
                  </div>
                ))}
                <div style={{borderTop:`1.5px solid ${C.pink}22`,marginTop:12,paddingTop:12,display:"flex",justifyContent:"space-between"}}>
                  <span style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:C.brown}}>Total</span>
                  <span style={{fontFamily:"Nunito,sans-serif",fontSize:18,fontWeight:800,color:C.pink}}>{fmtMoney(subtotal)}</span>
                </div>
              </div>

              <div style={{background:C.white,borderRadius:16,border:`1.5px solid ${C.paper}`,padding:"18px",marginBottom:16}}>
                <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:13,color:C.brown,marginBottom:14}}>
                  Datos para entrega y contacto
                </div>
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",gap:12}}>
                  {[
                    { key:"name", label:"Nombre completo", type:"text", required:true },
                    { key:"phone", label:"Telefono", type:"text", required:true },
                    { key:"email", label:"Email", type:"email" },
                    { key:"instagram", label:"Instagram", type:"text" },
                    { key:"city", label:"Ciudad / municipio", type:"text", required:true },
                    { key:"country", label:"Pais", type:"text" },
                  ].map((field) => (
                    <label key={field.key} className="sans" style={{fontSize:12,fontWeight:700,color:C.brown,display:"flex",flexDirection:"column",gap:6}}>
                      {field.label}{field.required ? " *" : ""}
                      <input
                        type={field.type}
                        value={customer[field.key]}
                        onChange={(e) => setCustomer((prev) => ({ ...prev, [field.key]: e.target.value }))}
                        style={{padding:"11px 12px",borderRadius:12,border:`1.5px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:13}}
                      />
                    </label>
                  ))}
                  <label className="sans" style={{fontSize:12,fontWeight:700,color:C.brown,display:"flex",flexDirection:"column",gap:6}}>
                    Zona de envio
                    <select
                      value={customer.shippingZone}
                      onChange={(e) => setCustomer((prev) => ({ ...prev, shippingZone: e.target.value }))}
                      style={{padding:"11px 12px",borderRadius:12,border:`1.5px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:13,background:C.white}}
                    >
                      {SHIPPING_ZONES.map((zone) => (
                        <option key={zone.id} value={zone.id}>{zone.label}</option>
                      ))}
                    </select>
                  </label>
                </div>
                <label className="sans" style={{fontSize:12,fontWeight:700,color:C.brown,display:"flex",flexDirection:"column",gap:6,marginTop:12}}>
                  Direccion de entrega
                  <textarea
                    value={customer.address}
                    onChange={(e) => setCustomer((prev) => ({ ...prev, address: e.target.value }))}
                    rows={3}
                    style={{padding:"11px 12px",borderRadius:12,border:`1.5px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:13,resize:"vertical"}}
                  />
                </label>
                <label className="sans" style={{fontSize:12,fontWeight:700,color:C.brown,display:"flex",flexDirection:"column",gap:6,marginTop:12}}>
                  Notas del pedido
                  <textarea
                    value={customer.notes}
                    onChange={(e) => setCustomer((prev) => ({ ...prev, notes: e.target.value }))}
                    rows={2}
                    style={{padding:"11px 12px",borderRadius:12,border:`1.5px solid ${C.paper}`,fontFamily:"Nunito,sans-serif",fontSize:13,resize:"vertical"}}
                  />
                </label>
              </div>

              {/* Shipping note */}
              <div style={{background:"#fffbeb",borderRadius:12,padding:"12px 16px",border:"1.5px solid #fde68a",display:"flex",gap:10,alignItems:"flex-start",marginBottom:20}}>
                <span style={{fontSize:18,flexShrink:0}}>📦</span>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:"#78350f",lineHeight:1.65,margin:0}}>
                  El envío en El Salvador se calcula por zona. Para Estados Unidos, Abu confirma el costo final contigo.
                </p>
              </div>
              <div style={{background:"#eff6ff",borderRadius:12,padding:"12px 16px",border:"1.5px solid #bfdbfe",display:"flex",gap:10,alignItems:"flex-start",marginBottom:20}}>
                <span style={{fontSize:18,flexShrink:0}}>🛡️</span>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:"#1e3a8a",lineHeight:1.65,margin:0}}>
                  Tu pieza solo se marca como vendida cuando Wompi confirma el pago exitosamente.
                </p>
              </div>

              {/* Wompi pay button */}
              <div style={{background:C.white,borderRadius:16,border:`2px solid ${C.paper}`,padding:"20px",textAlign:"center"}}>
                {/* Wompi logo */}
                <div style={{display:"flex",alignItems:"center",justifyContent:"center",gap:10,marginBottom:14}}>
                  <div style={{width:38,height:38,borderRadius:10,background:"linear-gradient(135deg,#5b2d8e,#9b4dca)",
                    display:"flex",alignItems:"center",justifyContent:"center",fontSize:18,boxShadow:"0 3px 10px rgba(91,45,142,.3)"}}>
                    💳
                  </div>
                  <div style={{textAlign:"left"}}>
                    <div style={{fontFamily:"Nunito,sans-serif",fontWeight:800,fontSize:16,color:"#5b2d8e",lineHeight:1}}>Wompi</div>
                    <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt,marginTop:2}}>Pago 100% seguro</div>
                  </div>
                </div>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd,lineHeight:1.7,marginBottom:16}}>
                  Acepta <strong>tarjeta de crédito/débito</strong>, Puntos Agrícola, Bitcoin (Chivo Wallet) y más.<br/>
                  Serás redirigido a la plataforma segura de Wompi El Salvador.
                </p>
                {/* Payment icons row */}
                <div style={{display:"flex",justifyContent:"center",gap:8,marginBottom:18,flexWrap:"wrap"}}>
                  {["Visa","Mastercard","Puntos Agrícola","Bitcoin","Chivo Wallet"].map(label => (
                    <span key={label} style={{fontFamily:"Nunito,sans-serif",fontSize:10,fontWeight:800,
                      padding:"4px 9px",borderRadius:20,background:C.paper,color:C.brownMd,border:`1px solid ${C.paper}`}}>
                      {label}
                    </span>
                  ))}
                </div>
                <button onClick={handleWompi}
                  style={{width:"100%",padding:"15px 0",borderRadius:50,border:"none",
                    background:"linear-gradient(135deg,#5b2d8e,#9b4dca)",color:"white",
                    fontFamily:"Nunito,sans-serif",fontSize:16,fontWeight:800,cursor:"pointer",
                    boxShadow:"0 4px 0 #4a2270",transition:"opacity .2s"}}
                  onMouseEnter={e=>e.currentTarget.style.opacity=".9"}
                  onMouseLeave={e=>e.currentTarget.style.opacity="1"}>
                  Pagar {fmtMoney(subtotal)} con Wompi →
                </button>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:C.brownLt,marginTop:10}}>
                  🔒 Transacción cifrada · Certificado PCI DSS
                </p>
              </div>
            </div>
          )}

          {/* LOADING */}
          {step==="loading" && (
            <div style={{textAlign:"center",padding:"40px 0"}}>
              <div style={{fontSize:50,marginBottom:16,animation:"spin 1s linear infinite"}}>⏳</div>
              <p style={{fontFamily:"Nunito,sans-serif",fontSize:15,fontWeight:700,color:C.brown,marginBottom:8}}>
                Conectando con Wompi...
              </p>
              <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd}}>
                Generando tu enlace de pago seguro.
              </p>
            </div>
          )}

          {/* ERROR */}
          {step==="error" && (
            <div style={{textAlign:"center",padding:"32px 0"}}>
              <div style={{fontSize:48,marginBottom:14}}>😔</div>
              <h3 style={{fontFamily:"Playfair Display,serif",fontSize:20,marginBottom:8,color:C.brown}}>No se pudo crear el pago</h3>
              <div style={{background:"#fff0f0",borderRadius:12,padding:"12px 16px",border:"1.5px solid #fca5a5",marginBottom:20}}>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:"#991b1b",margin:0}}>{errMsg}</p>
              </div>
              <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd,lineHeight:1.7,marginBottom:16}}>
                Puedes intentar de nuevo o escribirle directamente a Abu por Instagram.
              </p>
              <a href={`https://www.instagram.com/${IG_HANDLE}/`} target="_blank" rel="noreferrer"
                style={{display:"inline-flex",alignItems:"center",gap:8,
                  background:`linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)`,color:"white",
                  padding:"12px 24px",borderRadius:50,fontFamily:"Nunito,sans-serif",
                  fontSize:14,fontWeight:800,textDecoration:"none"}}>
                📸 Ir a @{IG_HANDLE}
              </a>
            </div>
          )}

          {/* STEP 2 — DONE */}
          {step==="done" && (
            <div style={{textAlign:"center",padding:"8px 0"}}>
              <div style={{fontSize:60,marginBottom:14}}>🎉</div>
              <h3 style={{fontFamily:"Playfair Display,serif",fontSize:22,marginBottom:8,color:C.brown}}>¡Pedido registrado!</h3>
              <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd,marginBottom:14,lineHeight:1.7}}>
                Completaste el pago con Wompi. Guarda tu número de pedido: Abu revisará tu información de entrega y te contactará si hace falta algo más.
              </p>

              {/* Order ID card */}
              <div style={{background:`linear-gradient(135deg,${C.pink},${C.purple})`,borderRadius:18,padding:"18px 24px",marginBottom:20,width:"100%",boxSizing:"border-box"}}>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:11,color:"rgba(255,255,255,.7)",marginBottom:6,textTransform:"uppercase",letterSpacing:"2px"}}>Tu número de pedido</div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:28,fontWeight:800,color:"white",letterSpacing:3}}>{orderId}</div>
                <div style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:"rgba(255,255,255,.65)",marginTop:6}}>{fmtMoney(subtotal)} · {cart.map(p=>p.name).join(", ")}</div>
              </div>

              {/* IG redirect */}
              <div style={{background:C.paper,borderRadius:16,padding:"18px",border:`1.5px solid ${C.pink}22`,marginBottom:16,textAlign:"left"}}>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,color:C.brown,marginBottom:8}}>
                  Resumen para tu seguimiento
                </p>
                <p style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brownMd,lineHeight:1.75,marginBottom:16}}>
                  Puedes guardar estos datos y escribirle a Abu solo si quieres agregar una aclaración adicional.
                </p>
                <div style={{display:"flex",flexDirection:"column",gap:7,marginBottom:18}}>
                  {[`🔖 Número de pedido: ${orderId}`,"📍 Dirección ya registrada en tu pedido","💳 Comprobante de pago Wompi"].map((item,i) => (
                    <div key={i} style={{display:"flex",alignItems:"center",gap:8,background:C.white,borderRadius:10,padding:"9px 12px",border:`1px solid ${C.paper}`}}>
                      <span style={{fontFamily:"Nunito,sans-serif",fontSize:13,color:C.brown}}>{item}</span>
                    </div>
                  ))}
                </div>
                <a href={igDMUrl} target="_blank" rel="noreferrer"
                  style={{display:"flex",alignItems:"center",justifyContent:"center",gap:8,
                    background:`linear-gradient(135deg,#833ab4,#fd1d1d,#fcb045)`,color:"white",
                    padding:"14px 0",borderRadius:50,fontFamily:"Nunito,sans-serif",
                    fontSize:15,fontWeight:800,textDecoration:"none",
                    boxShadow:"0 4px 16px rgba(131,58,180,.35)"}}>
                  <span style={{fontSize:18}}>📸</span> Ir a @{IG_HANDLE} →
                </a>
              </div>
              <p style={{fontFamily:"Nunito,sans-serif",fontSize:12,color:C.brownLt}}>¡Gracias por tu compra! Abu responderá pronto 🌸</p>
            </div>
          )}
        </div>

        {/* ── FOOTER ── */}
        <div style={{padding:"14px 24px",borderTop:`1.5px solid ${C.paper}`,background:C.white,flexShrink:0,display:"flex",gap:10}}>
          {step==="summary" && (
            <button onClick={onClose}
              style={{padding:"11px 18px",borderRadius:50,border:`2px solid ${C.paper}`,background:"transparent",
                fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brownMd,cursor:"pointer"}}>
              ← Carrito
            </button>
          )}
          {step==="error" && (
            <>
              <button onClick={()=>setStep("summary")}
                style={{padding:"11px 18px",borderRadius:50,border:`2px solid ${C.paper}`,background:"transparent",
                  fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brownMd,cursor:"pointer"}}>
                ← Atrás
              </button>
              <button onClick={handleWompi}
                style={{flex:1,padding:"13px 0",borderRadius:50,border:"none",
                  background:`linear-gradient(135deg,#5b2d8e,#9b4dca)`,color:"white",
                  fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:800,cursor:"pointer"}}>
                Reintentar →
              </button>
            </>
          )}
          {step==="done" && (
            <button onClick={onClose}
              style={{flex:1,padding:"12px 0",borderRadius:50,border:`2px solid ${C.paper}`,background:"transparent",
                fontFamily:"Nunito,sans-serif",fontSize:14,fontWeight:700,color:C.brownMd,cursor:"pointer"}}>
              Cerrar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
//  ADMIN COMPONENTS
// ─────────────────────────────────────────────────────────────────────────────

export { ProductCard, CheckoutModal };
